import {setLoading, useMaterialUIController} from "../../Context/mui";
import DashboardNavbar from "../../Components/Navbars/DashboardNavbar";
import DashboardLayout from "../../Components/LayoutContainers/DashboardLayout";
import MDTableCell from "../../Components/MDTable/MDTableCell";
import {
    Autocomplete,
    ButtonBase,
    Grid,
    Slide,
    TableBody,
    TableContainer,
    TableHead,
    TablePagination,
    TableRow, TextField
} from "@mui/material";
import {Table} from "reactstrap";
import MDBox from "../../Components/MDBox";
import Paper from "@mui/material/Paper";
import MDTableRow from "../../Components/MDTable/MDTableRow";
import React, {forwardRef, useEffect, useState} from "react";
import {MessageModel} from "../../Api/Model/MessageModel";
import Cookies from "js-cookie";
import {v4 as uuid} from "uuid"
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import {ReactComponent as DeleteIcon} from '../../Asset/images/icons/deleteicon.svg'
import {ReactComponent as Moshahede} from '../../Asset/images/icons/lets-icons_view.svg'
import MDTypography from "../../Components/MDTypography";
import MDInput from "../../Components/MDInput";
import MDDate from "../../Components/MDDate";
import MDButton from "../../Components/MDButton";
import {ErrorToaast, InfoToaast} from "../../utils/toast/Toast";
import MDSelect from "../../Components/MDSelect";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import {CurrentUser} from "../../utils/Hooks/currentUser";
import {UserModel} from "../../Api/Model/UserModel";
import AddAlertIcon from '@mui/icons-material/AddAlert';
import MedicalInformationIcon from '@mui/icons-material/MedicalInformation';
import {Info} from "@mui/icons-material";
import RateReviewIcon from '@mui/icons-material/RateReview';
import {NoskheModel} from "../../Api/Model/NoskheModel";

const initalSearchParams = {
    Name: "",
    CodeMeli: "",
    AzSabt: "",
    TaSabt: "",
};
const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});
export default function StudentInfoPage() {
    const [pageNumber, setPageNumber] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [counter, setCounter] = useState(0)
    const [giveMedalTitle, setGiveMedalTitle] = useState("")
    const [studentHealthInofrmationHistory, setStudentHealthInofrmationHistory] = useState([]);
    const [studentLifeHistory, setStudentLifeHistory] = useState([])
    const [sahebcodeMeli, setSahebCodeMeli] = useState(null);
    const [studentInfoDialog, setStudentInfoDialog] = useState({open: false, model: null});
    const [studentHealthDialog, setStudentHealthDialog] = useState({open: false, model: null});
    const [studentLifeDialog, setStudentLifeDialog] = useState({open: false, model: null});
    const [studentGiveMedalDialog, setStudentGiveMedalDialog] = useState({open: false, id: null, kind: null});
    const [studentShowMedalDialog, setStudentShowMedalDialog] = useState({open: false, model: null});
    const [studentNoskheDialog, setStudentNoskheDialog] = useState({open: false, id: null});
    const [studentNosakhDialog, setStudentNosakhDialog] = useState({open: false, id: null});
    const [onvanmsg, setOnvanMsg] = React.useState("");
    const [textMsg, setTextMsg] = React.useState("");
    const [noskhepageNumber, setNoskhePageNumber] = useState(1);
    const [noskhepageSize, setNoskhePageSize] = useState(10);
    const [searchParams, setSearchParams] = useState(initalSearchParams);
    const [rows, setRows] = useState({
        content: [],
        pageSize: 0,
        totalPages: 0,
    });
    const [noskheRows, setNoskheRows] = useState({
        content: [],
        pageSize: 0,
        totalPages: 0,
    });
    const [controller, dispatch] = useMaterialUIController();
    const {loading} = controller;
    let Api = new UserModel(Cookies.get("cst") ?? "");
    let ApiNoskhe = new NoskheModel(Cookies.get("cst") ?? "");
    useEffect(() => {
        setLoading(dispatch, true);
        Api
            .getStudentsPaginate(pageNumber, pageSize)
            .then((r) => {
                setRows(r.data.data);
            })

            .catch
            (r => {
                if (r?.status == 404) {
                    setLoading(dispatch, false)

                    return
                }
                ErrorToaast("دریافت اطلاعات با مشکل مواجه شد")
                setLoading(dispatch, false)

            })
            .finally(() => {
                setLoading(dispatch, false);
            });


    }, [pageNumber, pageSize, counter]);
    const handleChangePage = (event, newPage) => {
        setPageNumber(newPage + 1);
    };
    const handleChangeNoskhePage = (event, newPage) => {
        setnoskhePageNumber(newPage + 1);
    };
    const handleChangeRowsPerPage = (
        event
    ) => {
        setPageSize(+event.target.value);
        setPageNumber(1);
    };
    const handleChangeNoskheRowsPerPage = (
        event
    ) => {
        setNoskhePageSize(+event.target.value);
        setNoskhePageNumber(1);
    };

    function defaultLabelDisplayedRows({from, to, count}) {
        return `${from}–${to} از ${
            count !== -1 ? count : `بیشتر از ${to}`
        }`;
    }

    function handleSearch() {
        const {Name, CodeMeli, AzSabt, TaSabt} = searchParams;
        if (
            Name === "" &&
            AzSabt === "" &&
            TaSabt === "" &&
            CodeMeli === ""
        ) {
            return setCounter((c) => c + 1);
        } else {
            setLoading(dispatch, true);
            Api
                .GetSearch(
                    searchParams.Name,
                    searchParams.CodeMeli,
                    searchParams.AzSabt,
                    searchParams.TaSabt,
                )
                .then((r) => {
                    setRows({content: r.data.data, pageSize: 0, totalPages: 0});
                    setLoading(dispatch, false);
                })
                .catch((r) => {
                    setLoading(dispatch, false);
                    ErrorToaast("دریافت اطلاعات با مشکل مواجه شد");
                });
        }
    }

    function handleClickOpenInformation(id) {
        Api
            .GetStudentInfo(id)
            .then((r) => {
                setStudentInfoDialog({model: r.data.data, open: true})
            })
            .catch(() => {
                ErrorToaast("این قسمت تکمیل نشده است")
            });
    }

    function handleClickOpenLife(id,modelId = "") {
        Api
            .GetStudentLifeStyle(modelId, id)
            .then((r) => {
                setStudentLifeDialog({model: r.data.data, open: true})
            })
            .then(p => {
                if (studentLifeHistory.length < 1)
                    Api.GetStudentLifeStyleHistory(id).then(r => {
                        setStudentLifeHistory(r.data.data);
                    })
            })
            .catch(() => {
                ErrorToaast("این قسمت تکمیل نشده است")
            });
    }

    function handleCloseInformation() {
        setStudentInfoDialog({model: null, open: false})

    }

    function handleCloseHealth() {
        setStudentHealthDialog({model: null, open: false})
        setStudentHealthInofrmationHistory([])
    }

    function handleCloseLife() {
        setStudentLifeDialog({model: null, open: false})

    }

    function handleCloseGiveMedal() {
        setStudentGiveMedalDialog({open: false, id: null, kind: null})

    }

    function handleClickOpenHealth(id, modelId = "") {
        Api
            .GetStudentSalamatInfo(modelId, id)
            .then((r) => {
                setStudentHealthDialog({model: r.data.data, open: true})
            })
            .then(p => {
                if (studentHealthInofrmationHistory.length < 1)
                    Api.GetStudentSalamatInfoHistory(id).then(r => {
                        setStudentHealthInofrmationHistory(r.data.data);
                    })
            })
            .catch(() => {
                ErrorToaast("خطا در دریافت اطلاعات")
            });
    }

    function handleSendGiveMedal() {
        if (giveMedalTitle === "")
            return ErrorToaast("عنوان مدال را انتخاب کنید")
        Api
            .GiveStudentMedals({
                Title: giveMedalTitle,
                MedalType: studentGiveMedalDialog.kind,
                UserId: studentGiveMedalDialog.id
            })
            .then((r) => {
                InfoToaast("مدال با موفقیت اهدا شد")
                setGiveMedalTitle("")
                setStudentGiveMedalDialog({id: null, kind: null, open: false})
            })
            .catch(() => {
                ErrorToaast("خطا در دریافت اطلاعات")
            });
    }

    function handleClickOpenShowMedal(id) {
        Api
            .GetMedal(id)
            .then((r) => {
                setStudentShowMedalDialog({model: r.data.data, open: true})
            })
            .catch(() => {
                ErrorToaast("خطا در دریافت اطلاعات")
            });
    }

    function handleCloseShowMedal() {
        setStudentShowMedalDialog({model: null, open: false})
    }

    function handleCloseNoskhe() {
        setOnvanMsg("")
        setTextMsg("")
        setStudentNoskheDialog({open: false, id: null})

    }

    function handleSendNoskhe() {

        if (onvanmsg === "" || textMsg === "") {
            ErrorToaast("لطفا مقادیر را پر کنید")
            return;
        }
        Api
            .GiveNoskhe({
                Text: textMsg,
                Title: onvanmsg,
                StudentId: studentNoskheDialog?.id
            })
            .then((r) => {
                handleCloseNoskhe()

                InfoToaast("نسخه با موفقیت ارسال شد")

            })
            .finally(() => {
                setLoading(dispatch, false);
            });
    }

    function openNosakh(id) {
        ApiNoskhe
            .getAllWithPaginate(id, noskhepageNumber, noskhepageSize)
            .then((r) => {
                setNoskheRows(r.data.data);

            })
            .then(() => {
                setStudentNosakhDialog({
                    open: true,
                    id: id
                })
            })
            .catch(r => {
                if (r?.status == 404) {
                    setLoading(dispatch, false)

                    return
                }
                ErrorToaast("دریافت اطلاعات با مشکل مواجه شد")
                setLoading(dispatch, false)

            })
            .finally(() => {
                setLoading(dispatch, false);
            });

    }

    function handleAddSaheb() {
        if (sahebcodeMeli === null || sahebcodeMeli === "") {
            ErrorToaast("کد ملی را وارد کنید")
            return;
        }
        Api
            .AddSaheb(sahebcodeMeli)
            .then(r => {
                InfoToaast("دانش آموز با موفقیت افزوده شد")
                setSahebCodeMeli(null)
                setCounter((c) => c + 1);
            })
            .catch((e) => {
                ErrorToaast("خطا در افزودن دانش آموز")
            })
    }

    function handleChangeBmi(id) {
        setLoading(dispatch, true)
        Api.ChangeUserBmi(id).then(r => {
            setLoading(dispatch, false)
            setCounter(c => c + 1)
        }).catch(r => {
            setLoading(dispatch, false)
            ErrorToaast("دریافت اطلاعات با مشکل مواجه شد")
        })
    }

    return <DashboardLayout>

        <DashboardNavbar name={"اطلاعات دانش آموزان"}>
            اطلاعات دانش آموزان
        </DashboardNavbar>
        {(CurrentUser()?.Role === "Morabi" || CurrentUser()?.Role === "Parent") &&
            <MDBox py={3} bgColor={"#e8e8e8"} p={2} mb={2} borderRadius={20}>
                <MDTypography fontSize={14}>افزودن دانش آموز</MDTypography>
                <Grid
                    container
                    mb={2}
                    onKeyDown={(e) => e.key === "Enter" && handleSearch()}
                >
                    <Grid item container xs={12} md={6} lg={6} alignItems="center">
                        <Grid item xs={2} textAlign="center">
                            <MDTypography fontSize={14}>کد ملی</MDTypography>
                        </Grid>
                        <Grid item xs={8} my={1}>
                            <MDInput
                                size={"small"}
                                name="Name"
                                label={"کد ملی"}
                                fullWidth
                                onChange={(e) =>
                                    setSahebCodeMeli(e?.target?.value)
                                }
                                value={sahebcodeMeli}
                                focused
                                autoComplete="off"
                            />
                        </Grid>
                    </Grid>
                    <Grid item container xs={12} md={6} lg={6} alignItems="center">
                        <MDButton variant="text" color="info" onClick={handleAddSaheb}>
                            افزودن
                        </MDButton>
                        <MDButton
                            variant="text"
                            color="secondary"
                            onClick={() => {
                                setSahebCodeMeli("");
                            }}
                        >
                            انصراف
                        </MDButton>
                    </Grid>
                </Grid>
                <MDBox>

                </MDBox>


            </MDBox>
        }
        <MDBox py={3} bgColor={"#e8e8e8"} p={2} mb={2} borderRadius={20}>
            <MDTypography fontSize={14}>جستجو در فرم ها</MDTypography>
            <Grid
                container
                mb={2}
                onKeyDown={(e) => e.key === "Enter" && handleSearch()}
            >
                <Grid item container xs={12} md={6} lg={6} alignItems="center">
                    <Grid item xs={2} textAlign="center">
                        <MDTypography fontSize={14}>نام </MDTypography>
                    </Grid>
                    <Grid item xs={8} my={1}>
                        <MDInput
                            size={"small"}
                            name="Name"
                            label={"نام  "}
                            fullWidth
                            onChange={(e) =>
                                setSearchParams((p) => ({...p, Name: e.target.value}))
                            }
                            value={searchParams.Name}
                            focused
                            autoComplete="off"
                        />
                    </Grid>
                </Grid>
                <Grid item container xs={12} md={6} lg={6} alignItems="center">
                    <Grid item xs={2} textAlign="center">
                        <MDTypography fontSize={14}>{"کد ملی"}</MDTypography>
                    </Grid>
                    <Grid item xs={8} my={1}>
                        <MDInput
                            size={"small"}
                            name="CodeMeli"
                            label={"کد ملی  "}
                            fullWidth
                            onChange={(e) =>
                                setSearchParams((p) => ({
                                    ...p,
                                    CodeMeli: e.target.value,
                                }))
                            }
                            value={searchParams.CodeMeli}
                            focused
                            autoComplete="off"
                        />
                    </Grid>
                </Grid>
                <Grid item container xs={12} md={6} lg={6} alignItems="center">
                    <Grid item xs={2} textAlign="center">
                        <MDTypography fontSize={14}>از تاریخ</MDTypography>
                    </Grid>
                    <Grid item xs={8} my={1}>
                        <MDDate
                            name="FormDate"

                            onChange={(e) =>
                                setSearchParams((p) => ({
                                    ...p,
                                    AzSabt: e,
                                }))
                            }
                            defaultValue={searchParams.AzSabt}
                            label={"تاریخ "}
                            sx={{width: "100%"}}
                            portal
                            fullWidth
                            disabled={loading}
                        />

                    </Grid>
                </Grid>
                <Grid item container xs={12} md={6} lg={6} alignItems="center">
                    <Grid item xs={2} textAlign="center">
                        <MDTypography fontSize={14}>تا تاریخ</MDTypography>
                    </Grid>
                    <Grid item xs={8} my={1}>
                        <MDDate
                            name="FormDate"

                            onChange={(e) =>
                                setSearchParams((p) => ({
                                    ...p,
                                    TaSabt: e,
                                }))
                            }
                            defaultValue={searchParams.TaSabt}
                            label={"تاریخ "}
                            sx={{width: "100%"}}
                            portal
                            fullWidth
                            disabled={loading}
                        />

                    </Grid>
                </Grid>
            </Grid>
            <MDBox>
                <MDButton variant="text" color="primary" onClick={handleSearch}>
                    {"جستجو"}
                </MDButton>
                <MDButton
                    variant="text"
                    color="secondary"
                    onClick={() => {
                        setSearchParams(initalSearchParams);
                        setCounter((c) => c + 1);
                    }}
                >
                    {"انصراف"}
                </MDButton>
            </MDBox>
            <MDBox py={3} bgColor="#fff" p={2} mb={2} flex={1} borderRadius={2}>
                <Grid container flexDirection={"column"}>
                    <Grid item sx={{width: "100%"}}>
                        <TableContainer component={Paper} sx={{width: "100%"}}>
                            <Table sx={{minWidth: 700}} aria-label="customized table">
                                <TableHead>
                                    <TableRow>
                                        <MDTableCell align={"center"} style={{background: "#351F39"}}>
                                            تاریخ آخرین ویرایش
                                        </MDTableCell>
                                        <MDTableCell align={"center"} style={{background: "#351F39"}}>
                                            نام دانش آموز
                                        </MDTableCell>
                                        <MDTableCell align={"center"} style={{background: "#351F39"}}>
                                            کد ملی
                                        </MDTableCell>
                                        <MDTableCell align={"center"} style={{background: "#351F39"}}>
                                            اطلاعات فردی
                                        </MDTableCell>
                                        <MDTableCell align={"center"} style={{background: "#351F39"}}>
                                            اطلاعات سلامت
                                        </MDTableCell>
                                        <MDTableCell align={"center"} style={{background: "#351F39"}}>
                                            اطلاعات سبک زندگی
                                        </MDTableCell>

                                        <MDTableCell align={"center"} style={{background: "#351F39"}}>
                                            مدال
                                        </MDTableCell>
                                        {CurrentUser()?.Role === "Pezeshk" &&
                                            <MDTableCell align={"center"} style={{background: "#351F39"}}>
                                                هشدار BMI
                                            </MDTableCell>
                                        }
                                        <MDTableCell align={"center"} style={{background: "#351F39"}}>
                                            نسخه های تجویز شده
                                        </MDTableCell>
                                        {CurrentUser()?.Role === "Pezeshk" &&

                                            <MDTableCell align={"center"} style={{background: "#351F39"}}>
                                                تجویز نسخه
                                            </MDTableCell>
                                        }
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {rows?.content.length < 1 && (
                                        <MDTableRow
                                            sx={{
                                                "&:last-child td, &:last-child th": {border: 0},
                                            }}
                                        >
                                            <MDTableCell colSpan={9} align="right">
                                                بدون اطلاعات
                                            </MDTableCell>
                                        </MDTableRow>
                                    )}
                                    {rows?.content?.map((r) => {
                                        return (
                                            <MDTableRow
                                                hover
                                                role="checkbox"
                                                tabIndex={-1}
                                                key={uuid()}
                                            >
                                                <MDTableCell align={"center"}>
                                                    {new Date(r?.modified).toLocaleString('fa-IR')}
                                                </MDTableCell>
                                                <MDTableCell align={"center"}>
                                                    {r?.name + " " + r?.lastName}
                                                </MDTableCell>
                                                <MDTableCell align={"center"}>
                                                    {r?.codeMeli}
                                                </MDTableCell>
                                                <MDTableCell align={"center"}>
                                                    <Tooltip title="مشاهده">
                                                        <IconButton onClick={() => handleClickOpenInformation(r.id)}>
                                                            <Moshahede/>
                                                        </IconButton>
                                                    </Tooltip>

                                                </MDTableCell>

                                                <MDTableCell align={"center"}>
                                                    <Tooltip title="مشاهده">
                                                        <IconButton onClick={() => handleClickOpenHealth(r.id)}>
                                                            <Moshahede/>
                                                        </IconButton>
                                                    </Tooltip>

                                                </MDTableCell>

                                                <MDTableCell align={"center"}>
                                                    <Tooltip title="مشاهده">
                                                        <IconButton onClick={() => handleClickOpenLife(r.id)}>
                                                            <Moshahede/>
                                                        </IconButton>
                                                    </Tooltip>

                                                </MDTableCell>
                                                <MDTableCell align={"center"}>
                                                    <Tooltip title="مشاهده">
                                                        <IconButton onClick={() => handleClickOpenShowMedal(r.id)}>
                                                            <Moshahede/>
                                                        </IconButton>
                                                    </Tooltip>
                                                    {CurrentUser()?.Role === "Pezeshk" && <>

                                                        <Tooltip title="مدال ویژه">
                                                            <ButtonBase onClick={() => setStudentGiveMedalDialog({
                                                                id: r?.id,
                                                                open: true,
                                                                kind: 3
                                                            })} sx={{borderRadius: "100%", padding: 1}}>
                                                                <img height={30} width={30}
                                                                     src={require("../../Asset/images/medal4.png")}/>
                                                            </ButtonBase>
                                                        </Tooltip>
                                                        <Tooltip title="مدال طلا">
                                                            <ButtonBase onClick={() => setStudentGiveMedalDialog({
                                                                id: r?.id,
                                                                open: true,
                                                                kind: 0
                                                            })} sx={{borderRadius: "100%", padding: 1}}>
                                                                <img height={30} width={30}
                                                                     src={require("../../Asset/images/medal1.png")}/>
                                                            </ButtonBase>
                                                        </Tooltip>
                                                        <Tooltip title="مدال نقره">
                                                            <ButtonBase onClick={() => setStudentGiveMedalDialog({
                                                                id: r?.id,
                                                                open: true,
                                                                kind: 1
                                                            })} sx={{borderRadius: "100%", padding: 1}}>
                                                                <img height={30} width={30}
                                                                     src={require("../../Asset/images/medal2.png")}/>
                                                            </ButtonBase>
                                                        </Tooltip>
                                                        <Tooltip title="مدال برنز">
                                                            <ButtonBase onClick={() => setStudentGiveMedalDialog({
                                                                id: r?.id,
                                                                open: true,
                                                                kind: 2
                                                            })} sx={{borderRadius: "100%", padding: 1}}>
                                                                <img height={30} width={30}
                                                                     src={require("../../Asset/images/medal3.png")}/>
                                                            </ButtonBase>
                                                        </Tooltip>
                                                    </>
                                                    }
                                                </MDTableCell>
                                                {CurrentUser()?.Role === "Pezeshk" &&

                                                    <MDTableCell align={"center"}>
                                                        <Tooltip title={!r?.isBmi ? "بدون هشدار" : "دارای هشدار"}>
                                                            <IconButton color={"inherit"}
                                                                        sx={{color: r?.isBmi ? "red" : "green"}}
                                                                        onClick={() => handleChangeBmi(r?.id)}>
                                                                <AddAlertIcon/>
                                                            </IconButton>
                                                        </Tooltip>
                                                    </MDTableCell>
                                                }

                                                <MDTableCell align={"center"}>
                                                    <Tooltip title="نسخه تجویز شده">
                                                        <IconButton onClick={() => openNosakh(r?.id)}>
                                                            <RateReviewIcon/>
                                                        </IconButton>
                                                    </Tooltip>

                                                </MDTableCell>
                                                {CurrentUser()?.Role === "Pezeshk" &&

                                                    <MDTableCell align={"center"}>
                                                        <Tooltip title="تجویز نسخه">
                                                            <IconButton onClick={() => setStudentNoskheDialog({
                                                                open: true,
                                                                id: r?.id
                                                            })}>
                                                                <RateReviewIcon/>
                                                            </IconButton>
                                                        </Tooltip>

                                                    </MDTableCell>}
                                            </MDTableRow>


                                        );
                                    })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        {rows?.content.length > 0 && (
                            <TablePagination
                                rowsPerPageOptions={[10, 25, 100]}
                                component="div"
                                count={rows.totalPages}
                                rowsPerPage={pageSize}
                                page={pageNumber - 1}
                                onPageChange={handleChangePage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                                labelDisplayedRows={defaultLabelDisplayedRows}
                                labelRowsPerPage={<>تعداد در هر صفحه</>}
                            />
                        )}
                    </Grid>
                </Grid>

            </MDBox>

        </MDBox>
        {studentInfoDialog.open &&
            <Dialog
                open={studentInfoDialog.open}
                TransitionComponent={Transition}
                keepMounted
                onClose={handleCloseInformation}
                fullWidth

                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle>اطلاعات فردی</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-slide-description" sx={{fontSize: "26px"}}>
                        <Grid container rowSpacing={5} borderBottom={"1px solid #477B04"} py={4}>
                            <Grid container item spacing={4}>
                                <Grid item xs={12} md={6} lg={6}>
                                    <MDInput
                                        id="modified"
                                        name="modified"
                                        defaultValue={new Date(studentInfoDialog.model?.modified).toLocaleString('fa-IR')}
                                        autoComplete={"1"}
                                        disabled={true}
                                        width={"100%"}
                                        sx={{width: {xs: "100%", md: "100%", lg: "90%",}}}
                                        label={"تاریخ ویرایش"}/>
                                </Grid>
                                <Grid item xs={12} md={6} lg={6}>
                                    <MDInput
                                        id="name"
                                        name="name"
                                        defaultValue={studentInfoDialog.model?.name}
                                        autoComplete={"1"}
                                        disabled={true}
                                        width={"100%"}
                                        sx={{width: {xs: "100%", md: "100%", lg: "90%",}}}
                                        label={"نام"}/>
                                </Grid>
                                <Grid item xs={12} md={6} lg={6}>
                                    <MDInput
                                        id="lastName"
                                        name="lastName"
                                        defaultValue={studentInfoDialog.model?.lastName}
                                        autoComplete={"1"}
                                        disabled={true}
                                        width={"100%"}
                                        sx={{width: {xs: "100%", md: "100%", lg: "90%",}}}
                                        label={"نام خانوادگی"}/>
                                </Grid>
                                <Grid item xs={12} md={6} lg={6}>
                                    <MDInput
                                        id="sex"
                                        name="sex"
                                        defaultValue={studentInfoDialog.model?.sex}
                                        autoComplete={"1"}
                                        disabled={true}
                                        width={"100%"}
                                        sx={{width: {xs: "100%", md: "100%", lg: "90%",}}}
                                        label={"جنسیت"}/>
                                </Grid>
                                <Grid item xs={12} md={6} lg={6}>
                                    <MDInput
                                        id="addressSkoonat"
                                        name="addressSkoonat"
                                        defaultValue={studentInfoDialog.model?.addressSkoonat}
                                        autoComplete={"1"}
                                        disabled={true}
                                        width={"100%"}
                                        sx={{width: {xs: "100%", md: "100%", lg: "90%",}}}
                                        label={"آدرس محل سکونت"}/>
                                </Grid>
                                <Grid item xs={12} md={6} lg={6}>
                                    <MDInput
                                        id="birthCity"
                                        name="birthCity"
                                        defaultValue={studentInfoDialog.model?.birthCity}
                                        autoComplete={"1"}
                                        disabled={true}
                                        width={"100%"}
                                        sx={{width: {xs: "100%", md: "100%", lg: "90%",}}}
                                        label={"شهر تولد"}/>
                                </Grid>
                                <Grid item xs={12} md={6} lg={6}>
                                    <MDInput
                                        id="birthday"
                                        name="birthday"
                                        defaultValue={studentInfoDialog.model?.birthday}
                                        autoComplete={"1"}
                                        disabled={true}
                                        width={"100%"}
                                        sx={{width: {xs: "100%", md: "100%", lg: "90%",}}}
                                        label={"تاریخ تولد"}/>
                                </Grid>
                                <Grid item xs={12} md={6} lg={6}>
                                    <MDInput
                                        id="boomi"
                                        name="boomi"
                                        defaultValue={studentInfoDialog.model?.boomi}
                                        autoComplete={"1"}
                                        disabled={true}
                                        width={"100%"}
                                        sx={{width: {xs: "100%", md: "100%", lg: "90%",}}}
                                        label={"بومی"}/>
                                </Grid>
                                <Grid item xs={12} md={6} lg={6}>
                                    <MDInput
                                        id="cityTahsil"
                                        name="cityTahsil"
                                        defaultValue={studentInfoDialog.model?.cityTahsil}
                                        autoComplete={"1"}
                                        disabled={true}
                                        width={"100%"}
                                        sx={{width: {xs: "100%", md: "100%", lg: "90%",}}}
                                        label={"شهر تحصیل"}/>
                                </Grid>
                                <Grid item xs={12} md={6} lg={6}>
                                    <MDInput
                                        id="codeMeli"
                                        name="codeMeli"
                                        defaultValue={studentInfoDialog.model?.codeMeli}
                                        autoComplete={"1"}
                                        disabled={true}
                                        width={"100%"}
                                        sx={{width: {xs: "100%", md: "100%", lg: "90%",}}}
                                        label={"کد ملی"}/>
                                </Grid>
                                <Grid item xs={12} md={6} lg={6}>
                                    <MDInput
                                        id="dateSchool"
                                        name="dateSchool"
                                        defaultValue={studentInfoDialog.model?.dateSchool}
                                        autoComplete={"1"}
                                        disabled={true}
                                        width={"100%"}
                                        sx={{width: {xs: "100%", md: "100%", lg: "90%",}}}
                                        label={"تاریخ ورود به مدرسه"}/>
                                </Grid>

                                <Grid item xs={12} md={6} lg={6}>
                                    <MDInput
                                        id="fatherJob"
                                        name="fatherJob"
                                        defaultValue={studentInfoDialog.model?.fatherJob}
                                        autoComplete={"1"}
                                        disabled={true}
                                        width={"100%"}
                                        sx={{width: {xs: "100%", md: "100%", lg: "90%",}}}
                                        label={"شغل پدر"}/>
                                </Grid>
                                <Grid item xs={12} md={6} lg={6}>
                                    <MDInput
                                        id="fatherName"
                                        name="fatherName"
                                        defaultValue={studentInfoDialog.model?.fatherName}
                                        autoComplete={"1"}
                                        disabled={true}
                                        width={"100%"}
                                        sx={{width: {xs: "100%", md: "100%", lg: "90%",}}}
                                        label={"نام پدر"}/>
                                </Grid>

                                <Grid item xs={12} md={6} lg={6}>
                                    <MDInput
                                        id="mazhab"
                                        name="mazhab"
                                        defaultValue={studentInfoDialog.model?.mazhab}
                                        autoComplete={"1"}
                                        disabled={true}
                                        width={"100%"}
                                        sx={{width: {xs: "100%", md: "100%", lg: "90%",}}}
                                        label={"مذهب"}/>
                                </Grid>

                                <Grid item xs={12} md={6} lg={6}>
                                    <MDInput
                                        id="motherJob"
                                        name="motherJob"
                                        defaultValue={studentInfoDialog.model?.motherJob}
                                        autoComplete={"1"}
                                        disabled={true}
                                        width={"100%"}
                                        sx={{width: {xs: "100%", md: "100%", lg: "90%",}}}
                                        label={"شغل مادر"}/>
                                </Grid>
                                <Grid item xs={12} md={6} lg={6}>
                                    <MDInput
                                        id="motherName"
                                        name="motherName"
                                        defaultValue={studentInfoDialog.model?.motherName}
                                        autoComplete={"1"}
                                        disabled={true}
                                        width={"100%"}
                                        sx={{width: {xs: "100%", md: "100%", lg: "90%",}}}
                                        label={"نام مادر"}/>
                                </Grid>


                                <Grid item xs={12} md={6} lg={6}>
                                    <MDInput
                                        id="noeBime"
                                        name="noeBime"
                                        defaultValue={studentInfoDialog.model?.noeBime}
                                        autoComplete={"1"}
                                        disabled={true}
                                        width={"100%"}
                                        sx={{width: {xs: "100%", md: "100%", lg: "90%",}}}
                                        label={"نوع بیمه"}/>
                                </Grid>
                                <Grid item xs={12} md={6} lg={6}>
                                    <MDInput
                                        id="noeSchoole"
                                        name="noeSchoole"
                                        defaultValue={studentInfoDialog.model?.noeSchoole}
                                        autoComplete={"1"}
                                        disabled={true}
                                        width={"100%"}
                                        sx={{width: {xs: "100%", md: "100%", lg: "90%",}}}
                                        label={"نوع مدرسه"}/>
                                </Grid>
                                <Grid item xs={12} md={6} lg={6}>
                                    <MDInput
                                        id="parentStatus"
                                        name="parentStatus"
                                        defaultValue={studentInfoDialog.model?.parentStatus}
                                        autoComplete={"1"}
                                        disabled={true}
                                        width={"100%"}
                                        sx={{width: {xs: "100%", md: "100%", lg: "90%",}}}
                                        label={"وضعیت والدین"}/>
                                </Grid>
                                <Grid item xs={12} md={6} lg={6}>
                                    <MDInput
                                        id="payeThsili"
                                        name="payeThsili"
                                        defaultValue={studentInfoDialog.model?.payeThsili}
                                        autoComplete={"1"}
                                        disabled={true}
                                        width={"100%"}
                                        sx={{width: {xs: "100%", md: "100%", lg: "90%",}}}
                                        label={"پایه تحصیلی"}/>
                                </Grid>

                                <Grid item xs={12} md={6} lg={6}>
                                    <MDInput
                                        id="phoneNumber"
                                        name="phoneNumber"
                                        defaultValue={studentInfoDialog.model?.phoneNumber}
                                        autoComplete={"1"}
                                        disabled={true}
                                        width={"100%"}
                                        sx={{width: {xs: "100%", md: "100%", lg: "90%",}}}
                                        label={"شماره تلفن"}/>
                                </Grid>

                                <Grid item xs={12} md={6} lg={6}>
                                    <MDInput
                                        id="sathTahsilat"
                                        name="sathTahsilat"
                                        defaultValue={studentInfoDialog.model?.sathTahsilat}
                                        autoComplete={"1"}
                                        disabled={true}
                                        width={"100%"}
                                        sx={{width: {xs: "100%", md: "100%", lg: "90%",}}}
                                        label={"سطح تحصیلات"}/>
                                </Grid>

                                <Grid item xs={12} md={6} lg={6}>
                                    <MDInput
                                        id="shomSkoonat"
                                        name="shomSkoonat"
                                        defaultValue={studentInfoDialog.model?.shomSkoonat}
                                        autoComplete={"1"}
                                        disabled={true}
                                        width={"100%"}
                                        sx={{width: {xs: "100%", md: "100%", lg: "90%",}}}
                                        label={"شماره محل سکونت"}/>
                                </Grid>

                                <Grid item xs={12} md={6} lg={6}>
                                    <MDInput
                                        id="taradodMadrse"
                                        name="taradodMadrse"
                                        defaultValue={studentInfoDialog.model?.taradodMadrse}
                                        autoComplete={"1"}
                                        disabled={true}
                                        width={"100%"}
                                        sx={{width: {xs: "100%", md: "100%", lg: "90%",}}}
                                        label={"وضعیت تردد به مدرسه"}/>
                                </Grid>


                            </Grid>
                        </Grid>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <MDButton variant={"outlined"} color={"info"} size={"large"}
                              onClick={handleCloseInformation}>بازگشت</MDButton>
                </DialogActions>
            </Dialog>
        }
        {studentHealthDialog.open &&
            <Dialog
                open={studentHealthDialog.open}
                TransitionComponent={Transition}
                keepMounted
                onClose={handleCloseHealth}
                fullWidth
                fullScreen
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle>اطلاعات سلامت</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-slide-description" sx={{fontSize: "26px"}}>

                        <Grid container rowSpacing={5} borderBottom={"1px solid #477B04"} py={4}>
                            <Grid container item spacing={4}>
                                <Grid item xs={12} md={6} lg={6}>
                                    <MDInput
                                        id="modified"
                                        name="modified"
                                        defaultValue={new Date(studentHealthDialog.model?.modified).toLocaleString('fa-IR')}
                                        autoComplete={"1"}
                                        disabled={true}
                                        width={"100%"}
                                        sx={{width: {xs: "100%", md: "100%", lg: "90%",}}}
                                        label={"تاریخ ویرایش"}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6} lg={6}>
                                    <MDInput
                                        id="height"
                                        name="height"
                                        defaultValue={studentHealthDialog.model?.height}
                                        autoComplete={"1"}
                                        disabled={true}
                                        width={"100%"}
                                        sx={{width: {xs: "100%", md: "100%", lg: "90%",}}}
                                        label={"قد"}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6} lg={6}>
                                    <MDInput
                                        id="weight"
                                        name="weight"
                                        defaultValue={studentHealthDialog.model?.weight}
                                        autoComplete={"1"}
                                        disabled={true}
                                        width={"100%"}
                                        sx={{width: {xs: "100%", md: "100%", lg: "90%",}}}
                                        label={"وزن"}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6} lg={6}>
                                    <MDInput
                                        id="bmi"
                                        name="bmi"
                                        defaultValue={studentHealthDialog.model?.bmi}
                                        autoComplete={"1"}
                                        disabled={true}
                                        width={"100%"}
                                        sx={{width: {xs: "100%", md: "100%", lg: "90%",}}}
                                        label={"BMI"}
                                    />
                                </Grid>

                                <Grid item xs={12} md={6} lg={6}>
                                    <MDInput
                                        id="azmayeshName"
                                        name="azmayeshName"
                                        defaultValue={studentHealthDialog.model?.azmayeshName}
                                        autoComplete={"1"}
                                        disabled={true}
                                        width={"100%"}
                                        sx={{width: {xs: "100%", md: "100%", lg: "90%",}}}
                                        label={"نام آزمایش"}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6} lg={6}>
                                    <MDInput
                                        id="azmayeshDate"
                                        name="azmayeshDate"
                                        defaultValue={studentHealthDialog.model?.azmayeshDate}
                                        autoComplete={"1"}
                                        disabled={true}
                                        width={"100%"}
                                        sx={{width: {xs: "100%", md: "100%", lg: "90%",}}}
                                        label={"تاریخ آزمایش"}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6} lg={6}>
                                    <MDInput
                                        id="azmayeshResult"
                                        name="azmayeshResult"
                                        defaultValue={studentHealthDialog.model?.azmayeshResult}
                                        autoComplete={"1"}
                                        disabled={true}
                                        width={"100%"}
                                        sx={{width: {xs: "100%", md: "100%", lg: "90%",}}}
                                        label={"نتیجه آزمایش"}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6} lg={6}>
                                    <MDInput
                                        id="azmayeshDalil"
                                        name="azmayeshDalil"
                                        defaultValue={studentHealthDialog.model?.azmayeshDalil}
                                        autoComplete={"1"}
                                        disabled={true}
                                        width={"100%"}
                                        sx={{width: {xs: "100%", md: "100%", lg: "90%",}}}
                                        label={"دلیل آزمایش"}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6} lg={6}>
                                    <MDInput
                                        id="azmayeshTafsir"
                                        name="azmayeshTafsir"
                                        defaultValue={studentHealthDialog.model?.azmayeshTafsir}
                                        autoComplete={"1"}
                                        disabled={true}
                                        width={"100%"}
                                        sx={{width: {xs: "100%", md: "100%", lg: "90%",}}}
                                        label={"تفسیر آزمایش"}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6} lg={6}>
                                    <MDInput
                                        id="azmayeshAlt"
                                        name="azmayeshAlt"
                                        defaultValue={studentHealthDialog.model?.azmayeshAlt}
                                        autoComplete={"1"}
                                        disabled={true}
                                        width={"100%"}
                                        sx={{width: {xs: "100%", md: "100%", lg: "90%",}}}
                                        label={"ALT"}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6} lg={6}>
                                    <MDInput
                                        id="azmayeshAST"
                                        name="azmayeshAST"
                                        defaultValue={studentHealthDialog.model?.azmayeshAST}
                                        autoComplete={"1"}
                                        disabled={true}
                                        width={"100%"}
                                        sx={{width: {xs: "100%", md: "100%", lg: "90%",}}}
                                        label={"AST"}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6} lg={6}>
                                    <MDInput
                                        id="azmayeshGGT"
                                        name="azmayeshGGT"
                                        defaultValue={studentHealthDialog.model?.azmayeshGGT}
                                        autoComplete={"1"}
                                        disabled={true}
                                        width={"100%"}
                                        sx={{width: {xs: "100%", md: "100%", lg: "90%",}}}
                                        label={"GGT"}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6} lg={6}>
                                    <MDInput
                                        id="prevBimary"
                                        name="prevBimary"
                                        defaultValue={studentHealthDialog.model?.prevBimary}
                                        autoComplete={"1"}
                                        disabled={true}
                                        width={"100%"}
                                        sx={{width: {xs: "100%", md: "100%", lg: "90%",}}}
                                        label={"سابقه بیماری"}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6} lg={6}>
                                    <MDInput
                                        id="hasasiat"
                                        name="hasasiat"
                                        defaultValue={studentHealthDialog.model?.hasasiat}
                                        autoComplete={"1"}
                                        disabled={true}
                                        width={"100%"}
                                        sx={{width: {xs: "100%", md: "100%", lg: "90%",}}}
                                        label={"حساسیت"}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6} lg={6}>
                                    <MDInput
                                        id="hdl"
                                        name="hdl"
                                        defaultValue={studentHealthDialog.model?.hdl}
                                        autoComplete={"1"}
                                        disabled={true}
                                        width={"100%"}
                                        sx={{width: {xs: "100%", md: "100%", lg: "90%",}}}
                                        label={"HDL"}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6} lg={6}>
                                    <MDInput
                                        id="triglycerides"
                                        name="triglycerides"
                                        defaultValue={studentHealthDialog.model?.triglycerides}
                                        autoComplete={"1"}
                                        disabled={true}
                                        width={"100%"}
                                        sx={{width: {xs: "100%", md: "100%", lg: "90%",}}}
                                        label={"تری گلیسیرید"}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6} lg={6}>
                                    <MDInput
                                        id="tCholestrol"
                                        name="tCholestrol"
                                        defaultValue={studentHealthDialog.model?.tCholestrol}
                                        autoComplete={"1"}
                                        disabled={true}
                                        width={"100%"}
                                        sx={{width: {xs: "100%", md: "100%", lg: "90%",}}}
                                        label={"کلسترول کل"}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6} lg={6}>
                                    <MDInput
                                        id="lholestrol"
                                        name="lholestrol"
                                        defaultValue={studentHealthDialog.model?.lholestrol}
                                        autoComplete={"1"}
                                        disabled={true}
                                        width={"100%"}
                                        sx={{width: {xs: "100%", md: "100%", lg: "90%",}}}
                                        label={"کلسترول LDL"}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6} lg={6}>
                                    <MDInput
                                        id="bimaryHistory"
                                        name="bimaryHistory"
                                        defaultValue={studentHealthDialog.model?.bimaryHistory}
                                        autoComplete={"1"}
                                        disabled={true}
                                        width={"100%"}
                                        sx={{width: {xs: "100%", md: "100%", lg: "90%",}}}
                                        label={"تاریخچه بیماری"}
                                    />
                                </Grid>

                            </Grid>
                            <Grid container item spacing={4}>
                                <Grid item xs={12}>
                                    <MDTypography variant="h6">داروها</MDTypography>
                                    <TableContainer component={Paper}>
                                        <Table>
                                            <TableHead>
                                                <TableRow>
                                                    <MDTableCell>نام دارو</MDTableCell>
                                                    <MDTableCell>زمان مصرف</MDTableCell>
                                                    <MDTableCell>مقدار</MDTableCell>
                                                    <MDTableCell>دوز</MDTableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {studentHealthDialog.model?.daroo.map((daroo) => (
                                                    <TableRow key={daroo.id}>
                                                        <MDTableCell>{daroo.darooName}</MDTableCell>
                                                        <MDTableCell>{daroo.darooZaman}</MDTableCell>
                                                        <MDTableCell>{daroo.darooGhat}</MDTableCell>
                                                        <MDTableCell>{daroo.darooDoz}</MDTableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Grid>
                            </Grid>
                            <Grid container item spacing={4}>
                                <Grid item xs={12}>
                                    <MDTypography variant="h6">واکسن‌ها</MDTypography>
                                    <TableContainer component={Paper}>
                                        <Table>
                                            <TableHead>
                                                <TableRow>
                                                    <MDTableCell>نوع واکسن</MDTableCell>
                                                    <MDTableCell>تاریخ</MDTableCell>
                                                    <MDTableCell>عوارض</MDTableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {studentHealthDialog.model?.vaksan.map((vaksan) => (
                                                    <TableRow key={vaksan.id}>
                                                        <MDTableCell>{vaksan.vaksanKind}</MDTableCell>
                                                        <MDTableCell>{vaksan.vaksanDate}</MDTableCell>
                                                        <MDTableCell>{vaksan.vaksanAvarez}</MDTableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid container item spacing={4}>
                            <Grid item xs={12}>
                                <MDTypography variant="h6">سوابق گذشته</MDTypography>
                                <TableContainer component={Paper}>
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                <MDTableCell>تاریخ ویرایش</MDTableCell>
                                                <MDTableCell>BMI</MDTableCell>
                                                <MDTableCell>عملیات</MDTableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {studentHealthInofrmationHistory.map((r) => (
                                                <TableRow key={r.id}>
                                                    <MDTableCell>
                                                        {new Date(r?.modified).toLocaleString('fa-IR')}
                                                    </MDTableCell>
                                                    <MDTableCell>{r.bmi}</MDTableCell>
                                                    <MDTableCell>
                                                        <Tooltip title="مشاهده">
                                                            <IconButton onClick={() => {
                                                                setStudentHealthDialog({model: null, open: false})
                                                                handleClickOpenHealth("", r.id)
                                                            }}>
                                                                <Moshahede/>
                                                            </IconButton>
                                                        </Tooltip>
                                                    </MDTableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Grid>
                        </Grid>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <MDButton variant={"outlined"} color={"info"} size={"large"}
                              onClick={handleCloseHealth}>بازگشت</MDButton>
                </DialogActions>
            </Dialog>
        }
        {studentLifeDialog.open &&
            <Dialog
                open={studentLifeDialog.open}
                TransitionComponent={Transition}
                keepMounted
                onClose={handleCloseLife}
                fullWidth
fullScreen
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle>اطلاعات سبک زندگی</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-slide-description" sx={{fontSize: "26px"}}>

                        <Grid container rowSpacing={5} borderBottom={"1px solid #477B04"} py={4}>
                            <Grid container item spacing={4}>
                                <Grid item xs={12} md={6} lg={6}>
                                    <MDInput
                                        id="modified"
                                        name="modified"
                                        defaultValue={new Date(studentLifeDialog.model?.modified).toLocaleString('fa-IR')}
                                        autoComplete={"1"}
                                        disabled={true}
                                        width={"100%"}
                                        sx={{width: {xs: "100%", md: "100%", lg: "90%",}}}
                                        label={"تاریخ ویرایش"}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6} lg={6}>
                                    <MDInput
                                        id="vadeGhaza"
                                        name="vadeGhaza"
                                        defaultValue={studentLifeDialog.model?.vadeGhaza}
                                        autoComplete={"1"}
                                        disabled={true}
                                        width={"100%"}
                                        sx={{width: {xs: "100%", md: "100%", lg: "90%",}}}
                                        label={"وعده غذا"}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6} lg={6}>
                                    <MDInput
                                        id="vadeHajm"
                                        name="vadeHajm"
                                        defaultValue={studentLifeDialog.model?.vadeHajm}
                                        autoComplete={"1"}
                                        disabled={true}
                                        width={"100%"}
                                        sx={{width: {xs: "100%", md: "100%", lg: "90%",}}}
                                        label={"حجم وعده"}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6} lg={6}>
                                    <MDInput
                                        id="vaziatTaghzie"
                                        name="vaziatTaghzie"
                                        defaultValue={studentLifeDialog.model?.vaziatTaghzie}
                                        autoComplete={"1"}
                                        disabled={true}
                                        width={"100%"}
                                        sx={{width: {xs: "100%", md: "100%", lg: "90%",}}}
                                        label={"وضعیت تغذیه"}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6} lg={6}>
                                    <MDInput
                                        id="eshteha"
                                        name="eshteha"
                                        defaultValue={studentLifeDialog.model?.eshteha}
                                        autoComplete={"1"}
                                        disabled={true}
                                        width={"100%"}
                                        sx={{width: {xs: "100%", md: "100%", lg: "90%",}}}
                                        label={"اشتها"}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6} lg={6}>
                                    <MDInput
                                        id="rezhimKhas"
                                        name="rezhimKhas"
                                        defaultValue={studentLifeDialog.model?.rezhimKhas}
                                        autoComplete={"1"}
                                        disabled={true}
                                        width={"100%"}
                                        sx={{width: {xs: "100%", md: "100%", lg: "90%",}}}
                                        label={"رژیم خاص"}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6} lg={6}>
                                    <MDInput
                                        id="khab"
                                        name="khab"
                                        defaultValue={studentLifeDialog.model?.khab}
                                        autoComplete={"1"}
                                        disabled={true}
                                        width={"100%"}
                                        sx={{width: {xs: "100%", md: "100%", lg: "90%",}}}
                                        label={"خواب"}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6} lg={6}>
                                    <MDInput
                                        id="badani"
                                        name="badani"
                                        defaultValue={studentLifeDialog.model?.badani}
                                        autoComplete={"1"}
                                        disabled={true}
                                        width={"100%"}
                                        sx={{width: {xs: "100%", md: "100%", lg: "90%",}}}
                                        label={"بدنی"}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6} lg={6}>
                                    <MDInput
                                        id="varzesh"
                                        name="varzesh"
                                        defaultValue={studentLifeDialog.model?.varzesh}
                                        autoComplete={"1"}
                                        disabled={true}
                                        width={"100%"}
                                        sx={{width: {xs: "100%", md: "100%", lg: "90%",}}}
                                        label={"ورزش"}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6} lg={6}>
                                    <MDInput
                                        id="ezterab"
                                        name="ezterab"
                                        defaultValue={studentLifeDialog.model?.ezterab}
                                        autoComplete={"1"}
                                        disabled={true}
                                        width={"100%"}
                                        sx={{width: {xs: "100%", md: "100%", lg: "90%",}}}
                                        label={"اضطراب"}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6} lg={6}>
                                    <MDInput
                                        id="khashm"
                                        name="khashm"
                                        defaultValue={studentLifeDialog.model?.khashm}
                                        autoComplete={"1"}
                                        disabled={true}
                                        width={"100%"}
                                        sx={{width: {xs: "100%", md: "100%", lg: "90%",}}}
                                        label={"خشم"}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6} lg={6}>
                                    <MDInput
                                        id="badKholgh"
                                        name="badKholgh"
                                        defaultValue={studentLifeDialog.model?.badKholgh}
                                        autoComplete={"1"}
                                        disabled={true}
                                        width={"100%"}
                                        sx={{width: {xs: "100%", md: "100%", lg: "90%",}}}
                                        label={"بدخلقی"}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6} lg={6}>
                                    <MDInput
                                        id="bihoslgi"
                                        name="bihoslgi"
                                        defaultValue={studentLifeDialog.model?.bihoslgi}
                                        autoComplete={"1"}
                                        disabled={true}
                                        width={"100%"}
                                        sx={{width: {xs: "100%", md: "100%", lg: "90%",}}}
                                        label={"بی حوصلگی"}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6} lg={6}>
                                    <MDInput
                                        id="estresStatus"
                                        name="estresStatus"
                                        defaultValue={studentLifeDialog.model?.estresStatus}
                                        autoComplete={"1"}
                                        disabled={true}
                                        width={"100%"}
                                        sx={{width: {xs: "100%", md: "100%", lg: "90%",}}}
                                        label={"وضعیت استرس"}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6} lg={6}>
                                    <MDInput
                                        id="barnameRizi"
                                        name="barnameRizi"
                                        defaultValue={studentLifeDialog.model?.barnameRizi}
                                        autoComplete={"1"}
                                        disabled={true}
                                        width={"100%"}
                                        sx={{width: {xs: "100%", md: "100%", lg: "90%",}}}
                                        label={"برنامه ریزی"}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6} lg={6}>
                                    <MDInput
                                        id="taroz"
                                        name="taroz"
                                        defaultValue={studentLifeDialog.model?.taroz}
                                        autoComplete={"1"}
                                        disabled={true}
                                        width={"100%"}
                                        sx={{width: {xs: "100%", md: "100%", lg: "90%",}}}
                                        label={"تعارض"}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6} lg={6}>
                                    <MDInput
                                        id="ravabet"
                                        name="ravabet"
                                        defaultValue={studentLifeDialog.model?.ravabet}
                                        autoComplete={"1"}
                                        disabled={true}
                                        width={"100%"}
                                        sx={{width: {xs: "100%", md: "100%", lg: "90%",}}}
                                        label={"روابط"}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6} lg={6}>
                                    <MDInput
                                        id="rezayatKh"
                                        name="rezayatKh"
                                        defaultValue={studentLifeDialog.model?.rezayatKh}
                                        autoComplete={"1"}
                                        disabled={true}
                                        width={"100%"}
                                        sx={{width: {xs: "100%", md: "100%", lg: "90%",}}}
                                        label={"رضایت خانوادگی"}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6} lg={6}>
                                    <MDInput
                                        id="tahsil"
                                        name="tahsil"
                                        defaultValue={studentLifeDialog.model?.tahsil}
                                        autoComplete={"1"}
                                        disabled={true}
                                        width={"100%"}
                                        sx={{width: {xs: "100%", md: "100%", lg: "90%",}}}
                                        label={"تحصیل"}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6} lg={6}>
                                    <MDInput
                                        id="taalol"
                                        name="taalol"
                                        defaultValue={studentLifeDialog.model?.taalol}
                                        autoComplete={"1"}
                                        disabled={true}
                                        width={"100%"}
                                        sx={{width: {xs: "100%", md: "100%", lg: "90%",}}}
                                        label={"تعامل"}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6} lg={6}>
                                    <MDInput
                                        id="behdasht"
                                        name="behdasht"
                                        defaultValue={studentLifeDialog.model?.behdasht}
                                        autoComplete={"1"}
                                        disabled={true}
                                        width={"100%"}
                                        sx={{width: {xs: "100%", md: "100%", lg: "90%",}}}
                                        label={"بهداشت"}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6} lg={6}>
                                    <MDInput
                                        id="rabteDustan"
                                        name="rabteDustan"
                                        defaultValue={studentLifeDialog.model?.rabteDustan}
                                        autoComplete={"1"}
                                        disabled={true}
                                        width={"100%"}
                                        sx={{width: {xs: "100%", md: "100%", lg: "90%",}}}
                                        label={"رابطه دوستان"}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6} lg={6}>
                                    <MDInput
                                        id="tozihat"
                                        name="tozihat"
                                        defaultValue={studentLifeDialog.model?.tozihat}
                                        autoComplete={"1"}
                                        disabled={true}
                                        width={"100%"}
                                        sx={{width: {xs: "100%", md: "100%", lg: "90%",}}}
                                        label={"توضیحات"}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid container item spacing={4}>
                            <Grid item xs={12}>
                                <MDTypography variant="h6">سوابق گذشته</MDTypography>
                                <TableContainer component={Paper}>
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                <MDTableCell>تاریخ ویرایش</MDTableCell>
                                                <MDTableCell>توضیحات</MDTableCell>
                                                <MDTableCell>عملیات</MDTableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            { studentLifeHistory.map((r) => (
                                                <TableRow key={r.id}>
                                                    <MDTableCell>
                                                        {new Date(r?.modified).toLocaleString('fa-IR')}
                                                    </MDTableCell>
                                                    <MDTableCell>{r?.tozihat    }</MDTableCell>
                                                    <MDTableCell>
                                                        <Tooltip title="مشاهده">
                                                            <IconButton onClick={() => {
                                                                setStudentLifeDialog({model: null, open: false})
                                                                handleClickOpenLife("", r.id)
                                                            }}>
                                                                <Moshahede/>
                                                            </IconButton>
                                                        </Tooltip>
                                                    </MDTableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Grid>
                        </Grid>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <MDButton variant={"outlined"} color={"info"} size={"large"}
                              onClick={handleCloseLife}>بازگشت</MDButton>
                </DialogActions>
            </Dialog>
        }
        {studentGiveMedalDialog.open &&
            <Dialog
                open={studentGiveMedalDialog.open}
                TransitionComponent={Transition}
                keepMounted

                onClose={handleCloseGiveMedal}
                fullWidth

                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle>اهدای مدال</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-slide-description" sx={{fontSize: "26px"}}>

                        <Grid container gap={5}>
                            <Grid item container gap={2}>
                                <MDTypography>
                                    نوع مدال
                                </MDTypography>
                                <MDTypography fontWeight={"bold"}>
                                    {studentGiveMedalDialog.kind === 0 && "طلا"}
                                    {studentGiveMedalDialog.kind === 1 && "نقره"}
                                    {studentGiveMedalDialog.kind === 2 && "برنز"}
                                    {studentGiveMedalDialog.kind === 3 && "ویژه"}
                                </MDTypography>
                            </Grid>
                            <Grid item container wrap={"nowrap"} gap={2} flex={1}>
                                <MDTypography>
                                    عنوان مدال
                                </MDTypography>
                                <MDSelect
                                    id="Vaziat"
                                    name="Vaziat"
                                    onChange={(r) => {
                                        setGiveMedalTitle(r)
                                    }}

                                    value={giveMedalTitle}

                                    disabled={loading}
                                    w={{xs: "100%", md: "100%", lg: "100%",}}
                                    label={"وضعیت"}>
                                    <option value={"تغذیه"}>تغذیه</option>
                                    <option value={"فعالیت بدنی"}>فعالیت بدنی</option>
                                    <option value={"سبک زندگی سالم"}>سبک زندگی سالم</option>


                                </MDSelect>

                            </Grid>
                        </Grid>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <MDButton variant={"outlined"} color={"warning"} size={"large"}
                              onClick={handleSendGiveMedal}>ارسال</MDButton>
                    <MDButton variant={"outlined"} color={"info"} size={"large"}
                              onClick={handleCloseGiveMedal}>بازگشت</MDButton>
                </DialogActions>
            </Dialog>
        }
        {studentShowMedalDialog.open &&
            <Dialog
                open={studentShowMedalDialog.open}
                TransitionComponent={Transition}
                keepMounted
                onClose={handleCloseShowMedal}
                fullWidth
                fullScreen

                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle>مدال ها</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-slide-description" sx={{fontSize: "26px"}}>

                        {studentShowMedalDialog.model.map((group, index) => (
                            <Grid container key={index} spacing={2} mb={4}>
                                <Grid item xs={12}>
                                    <MDTypography variant="h6">{group.title}</MDTypography>
                                </Grid>
                                <Grid item xs={12}>
                                    <TableContainer component={Paper}>
                                        <Table>
                                            <TableHead>
                                                <TableRow>
                                                    <MDTableCell>نوع مدال</MDTableCell>
                                                    <MDTableCell>تاریخ اهدا</MDTableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {group.medals.map((medal, idx) => (
                                                    <TableRow key={idx}>
                                                        <MDTableCell>
                                                            {medal.medalType === 0 && "طلا"}
                                                            {medal.medalType === 1 && "نقره"}
                                                            {medal.medalType === 2 && "برنز"}
                                                            {medal.medalType === 3 && "ویژه"}
                                                        </MDTableCell>
                                                        <MDTableCell>
                                                            {new Date(medal.modified).toLocaleString('fa-IR')}
                                                        </MDTableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Grid>
                            </Grid>
                        ))}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <MDButton variant={"outlined"} color={"info"} size={"large"}
                              onClick={handleCloseShowMedal}>بازگشت</MDButton>
                </DialogActions>
            </Dialog>
        }
        {studentNoskheDialog.open &&
            <Dialog
                open={studentNoskheDialog.open}
                TransitionComponent={Transition}
                keepMounted
                onClose={handleCloseNoskhe}
                fullWidth
                aria-describedby="alert-dialog-slide-description1"
            >
                <DialogTitle>تجویز نسخه</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-slide-description1" sx={{fontSize: "26px"}}>

                        <Grid container gap={5}>
                            <Grid item container gap={2}>
                                <MDTypography>
                                    ارسال از طرف
                                </MDTypography>
                                <MDTypography fontWeight={"bold"}>
                                    {CurrentUser()?.user?.UserName}
                                </MDTypography>
                            </Grid>

                            <Grid container item>
                                <MDInput
                                    id="onvanmsg"
                                    name="onvanmsg"
                                    value={onvanmsg}
                                    onChange={(r) => setOnvanMsg(r.target.value)}
                                    autoComplete={"1"}
                                    disabled={loading}
                                    w={{xs: "100%"}}
                                    fullWidth
                                    label={"عنوان نسخه"}/>

                            </Grid>
                            <Grid container item>
                                <MDInput
                                    id="textMsg"
                                    name="textMsg"
                                    multiline
                                    rows={4}
                                    value={textMsg}
                                    onChange={(r) => setTextMsg(r.target.value)}
                                    // error={
                                    //     Boolean(formik.errors.Varzesh)
                                    // }
                                    // helperText={formik.errors.Varzesh}
                                    autoComplete={"1"}
                                    disabled={loading}
                                    w={{xs: "100%"}}
                                    fullWidth
                                    label={"متن     "}/>

                            </Grid>
                        </Grid>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <MDButton variant={"outlined"} color={"warning"} size={"large"}
                              onClick={handleSendNoskhe}>ارسال</MDButton>
                    <MDButton variant={"outlined"} color={"info"} size={"large"}
                              onClick={handleCloseNoskhe}>بازگشت</MDButton>
                </DialogActions>

            </Dialog>
        }
        {studentNosakhDialog.open &&
            <Dialog
                open={studentNosakhDialog.open}
                TransitionComponent={Transition}
                keepMounted
                onClose={() => setStudentNosakhDialog({id: null, open: false})}
                fullScreen
                aria-describedby="alert-dialog-slide-description1"
            >
                <DialogTitle>لیست نسخه های دانش آموز</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-slide-description1" sx={{fontSize: "26px"}}>
                        <MDBox py={3} bgColor="#fff" p={2} mb={2} flex={1} borderRadius={2}>
                            <Grid container flexDirection={"column"}>
                                <Grid item sx={{width: "100%"}}>
                                    <TableContainer component={Paper} sx={{width: "100%"}}>
                                        <Table sx={{minWidth: 700}} aria-label="customized table">
                                            <TableHead>
                                                <TableRow>
                                                    <MDTableCell align={"center"} style={{background: "#351F39"}}>
                                                        نام پزشک
                                                    </MDTableCell>
                                                    <MDTableCell align={"center"} style={{background: "#351F39"}}>
                                                        نام دانش آموز
                                                    </MDTableCell>

                                                    <MDTableCell align={"center"} style={{background: "#351F39"}}>
                                                        تاریخ
                                                    </MDTableCell>
                                                    <MDTableCell align={"center"} style={{background: "#351F39"}}>
                                                        عنوان نسخه
                                                    </MDTableCell>
                                                    <MDTableCell width={400} align={"center"}
                                                                 style={{background: "#351F39"}}>
                                                        متن نسخه
                                                    </MDTableCell>

                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {noskheRows?.content.length < 1 && (
                                                    <MDTableRow
                                                        sx={{
                                                            "&:last-child td, &:last-child th": {border: 0},
                                                        }}
                                                    >
                                                        <MDTableCell colSpan={9} align="right">
                                                            بدون اطلاعات
                                                        </MDTableCell>
                                                    </MDTableRow>
                                                )}
                                                {noskheRows?.content?.map((r) => {
                                                    return (
                                                        <MDTableRow
                                                            hover
                                                            role="checkbox"
                                                            tabIndex={-1}
                                                            key={uuid()}
                                                        >
                                                            <MDTableCell align={"center"}>
                                                                {r?.doctorName + " " + r?.doctorLastName}
                                                            </MDTableCell>
                                                            <MDTableCell align={"center"}>
                                                                {r?.studentName + " " + r?.studentLastName}
                                                            </MDTableCell>
                                                            <MDTableCell align={"center"}>
                                                                {r?.doctorUserName}
                                                            </MDTableCell>

                                                            <MDTableCell align={"center"}>
                                                                {r?.title}
                                                            </MDTableCell>


                                                            <MDTableCell align={"center"}>
                                                                {r?.text}
                                                            </MDTableCell>


                                                        </MDTableRow>


                                                    );
                                                })}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                    {noskheRows?.content.length > 0 && (
                                        <TablePagination
                                            rowsPerPageOptions={[10, 25, 100]}
                                            component="div"
                                            count={noskheRows.totalPages}
                                            rowsPerPage={noskhepageSize}
                                            page={noskhepageNumber - 1}
                                            onPageChange={handleChangeNoskhePage}
                                            onRowsPerPageChange={handleChangeNoskheRowsPerPage}
                                            labelDisplayedRows={defaultLabelDisplayedRows}
                                            labelRowsPerPage={<>تعداد در هر صفحه</>}
                                        />
                                    )}
                                </Grid>
                            </Grid>

                        </MDBox>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <MDButton variant={"outlined"} color={"info"} size={"large"}
                              onClick={() => setStudentNosakhDialog({id: null, open: false})}>بازگشت</MDButton>
                </DialogActions>

            </Dialog>
        }
    </DashboardLayout>
}